import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { ReportService } from 'src/app/component/reports/reports-service/report.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-edi-report-modal',
  templateUrl: './edi-report-modal.component.html',
  styleUrls: ['./edi-report-modal.component.css']
})
export class EdiReportModalComponent implements OnInit, OnDestroy {
  @Input() reportData;
  @Output() onCloseModal = new EventEmitter<any>();
  reportDetails = [];
  status = [];
  selectedStatus = '';
  filterdataList: any = [];

  constructor(private reportService: ReportService) { }

  ngOnInit() {
    this.getreportDetail();
  }

  getreportDetail() {
    this.reportService.getEdiReportbyId(this.reportData._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.reportDetails = data;
        this.filterdataList = this.reportDetails;
        this.status = [];
        this.reportDetails.forEach(trip => {
          if (trip.status) {
            this.status.push(trip.status);
          }
        });
        this.status = _.uniq(this.status).sort();
      });
    this.filterTrips();
  }

  close() {
    this.onCloseModal.emit();
  }

  filterTrips() {
    this.filterdataList = this.reportDetails.filter(trip => {
      let isStatusExist = true;
      if (this.selectedStatus) {
        isStatusExist = trip.status === this.selectedStatus;
      }
      return isStatusExist;
    });
  }

  ngOnDestroy(): void { }
}
